import { useEffect, useState } from 'react';

const UuidPersistJS = () => {
    const [uuid, setUuid] = useState('');

    const generateUUID = () => {
        // Generate a UUID v4
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    useEffect(() => {
        const newUuid = generateUUID();
        setUuid(newUuid);
        // Store the UUID in a global variable so user code can access it
        window.currentUUID = newUuid;
    }, []);

    return (
        <div style={{ textAlign: 'left' }}>
            <h1>JavaScript: Persisting Data Between Page Loads</h1>
            <p>A new UUID is generated each time the browser is refreshed (hard reload, not just navigating between steps):</p>
            <div style={{ 
                padding: '15px', 
                backgroundColor: '#f0f0f0', 
                borderRadius: '5px', 
                fontFamily: 'monospace',
                fontSize: '18px',
                margin: '20px 0'
            }}>
                {uuid}
            </div>
            <p>The current UUID is stored in <code>window.currentUUID</code>.</p>
            <p><strong>Your Task:</strong></p>
            <ul>
                <li>Write JavaScript code that saves the current UUID as part of an <strong>array</strong></li>
                <li>The array should persist between page reloads - when you refresh the browser, old UUIDs should still be there</li>
                <li>Each time you run your code, it should add the current UUID to the array (not replace the whole array)</li>
                <li>Console log the full array of UUIDs</li>
            </ul>
            <p><em>Test by running your code, then refresh the browser to get a new UUID, and run it again. The array should grow.</em></p>
        </div>
    );
};

export default UuidPersistJS;

